import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../../assets/Logo.svg";
import { ReactComponent as LogoDark } from "../../../assets/Logo-dark.svg";
import { ReactComponent as ProfileIcon } from "../../../assets/dashboard/mobileDashboard/profile-circle.svg";
import { ReactComponent as ProfileIconDark } from "../../../assets/dashboard/mobileDashboard/profile-circle-dark.svg";
import { ReactComponent as AppearanceIcon } from "../../../assets/dashboard/mobileDashboard/Appearance.svg";
import { ReactComponent as AppearanceIconDark } from "../../../assets/dashboard/mobileDashboard/Appearance-dark.svg";
import { ReactComponent as ComponentsIcon } from "../../../assets/dashboard/mobileDashboard/row-vertical.svg";
import { ReactComponent as ComponentsIconDark } from "../../../assets/dashboard/mobileDashboard/row-vertical-dark.svg";
import { ReactComponent as LinkIcon } from "../../../assets/dashboard/link.svg";
import { ReactComponent as LinkIconDark } from "../../../assets/dashboard/link-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import DashboardMobilePreview from "../../previewPage/dashboardMobilePreview/DashboardMobilePreview";
import { useSelector } from "react-redux";
import useSettings from "../../../hooks/useSettings";
import useLocales from "../../../hooks/useLocales";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LoadingScreen from "../../../components/dashboard/LoadingScreen";
import { Helmet } from "react-helmet";
import OgImage from "../../../assets/landingPages/homePage/Hero.png";

import { useStateContext } from "../../../contexts/ThemeContext";

const PreviewWithBottomBar = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [width, setWidth] = useState(window.innerWidth);
  const { setisAddBlockTab } = useStateContext();

  useEffect(() => {
    if (width >= 768) {
      navigate("/dashboard/component");
      setisAddBlockTab(true);
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth >= 768) {
        navigate("/dashboard/component");
        setisAddBlockTab(true);
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );
  const [text, setText] = useState("");
  useEffect(() => {
    const url = window.location.origin + "/bill/" + user_data?.pageName;

    setText(url);
  }, [user_data]);

  const viewUserisLoading = useSelector(
    (state) => state?.adminUser?.viewUserisLoading
  );

  const { getBlockByPlanIdLoading } = useSelector(
    (state) => state?.paymentStripes
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Dashboard | Bil.Bio</title>
        <meta property="og:title" content="Dashboard | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      {viewUserisLoading || getBlockByPlanIdLoading ? (
        <LoadingScreen />
      ) : (
        <div className="flex flex-col">
          <div
            className={`flex items-center px-6 pt-10 ${
              themeDirection === "rtl" ? "flex-row-reverse" : ""
            }`}
          >
            {/* <Link to={"/"}>
              {darkMode ? (
                <LogoDark className="h-[20px] w-[80px]" />
              ) : (
                <Logo className="h-[20px] w-[80px]" />
              )}
            </Link> */}
          </div>
          <CopyToClipboard text={text}>
            <a href={text} target="_blank" rel="noopener noreferrer">
              <div
                className={`py-[7px] mt-6 px-[10px] mx-6 mb-2 bg-light_bg_v3  dark:bg-dark-secondary flex items-center gap-2 rounded-md ${
                  themeDirection === "rtl" ? "flex-row-reverse" : ""
                }`}
              >
                <div>{darkMode ? <LinkIconDark /> : <LinkIcon />}</div>
                <p className="text-small3 text-dark_bg_v4 dark:text-color_v1_dark flex items-center">
                  URL : bilbio/{user_data?.pageName}
                </p>
              </div>
            </a>
          </CopyToClipboard>
          {/* h-[calc(100vh_-_228px)] */}
          <div className="h-[67dvh] min-h-[67dvh] px-6">
            <div className="bg-white bg rounded-[20px] h-full w-full overflow-y-auto p-0 border no-scrollbar">
              <DashboardMobilePreview user={user_data?.pageName} />
            </div>
          </div>
          {/*  -- clints css --
        fixed w-[100%] bottom-0 bg-[#FFF] p-[20px]

         -- actuall css -- 
        flex justify-center gap-[6px] mt-10 mb-4 mx-6 
        */}
          <div className="flex justify-center gap-[6px] fixed w-[100%] bottom-0 bg-[#FFF]  dark:bg-dark-secondary p-[20px] z-10">
            <Link
              to={"/dashboard/setting"}
              className="flex w-full flex-col justify-center items-center gap-[6px]"
            >
              {darkMode ? <ProfileIconDark /> : <ProfileIcon />}
              <p className="text-small2 text-dark_bg_v5 dark:text-color_v1_dark">
                {/* Profile */}
                {translate("cms.profile")}
              </p>
            </Link>
            <Link
              to={"/dashboard/component"}
              className="flex w-full flex-col justify-center items-center gap-[6px]"
            >
              {darkMode ? <ComponentsIconDark /> : <ComponentsIcon />}
              <p className="text-small2 text-dark_bg_v5 dark:text-color_v1_dark">
                {/* Components */}
                {translate("components")}
              </p>
            </Link>
            <Link
              to={"/dashboard/appearance"}
              className="flex w-full flex-col justify-center items-center gap-[6px]"
            >
              {darkMode ? <AppearanceIconDark /> : <AppearanceIcon />}
              <p className="text-small2 text-dark_bg_v5 dark:text-color_v1_dark">
                {/* Appearance */}
                {translate("cms.appearance")}
              </p>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewWithBottomBar;
